module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_6000.5b01ed6d.png";